import { Category } from '@core/domain/models/category.models';

export const InitialCategory: Category = {
    id: null,
    metadata: null,
    name: null,
    nameEn: null,
    redirectToCategoryId: null,
    isInformativeClickable: null,
    sectionPath: null,
    subcategories: null,
    attachments: null,
    locationPath: null,
    type: null,
};
